import { createTransformerLink } from 'apollo-client-transform'

/**
 * DateTime transformer to parse received GraphQL value (usually a timestamp) to a Date instance.
 */
const DateTimeTransformer = {
  parseValue(iso) {
    return iso ? new Date(iso) : iso
  },
}

/**
 * Defines which GraphQL fields should be automatically converted to DateTime.
 *
 * CAUTION: experimental, see https://github.com/apollographql/apollo-client/issues/585#issuecomment-400762881
 */
const transformers = {
  AdjustmentCertificate: {
    adjustmentDate: DateTimeTransformer,
    createdAt: DateTimeTransformer,
  },
  AlertComment: {
    date: DateTimeTransformer,
  },
  AuditLog: {
    date: DateTimeTransformer,
  },
  CalibrationCertificate: {
    calibrationDate: DateTimeTransformer,
    createdAt: DateTimeTransformer,
  },
  Alarm: {
    startDate: DateTimeTransformer,
    endDate: DateTimeTransformer,
    ackDate: DateTimeTransformer,
  },
  ChannelNote: {
    startDate: DateTimeTransformer,
    endDate: DateTimeTransformer,
  },
  Measurement: {
    date: DateTimeTransformer,
  },
  MeasurementStat: {
    minDate: DateTimeTransformer,
    maxDate: DateTimeTransformer,
  },
  SterilizationResult: {
    validationTime: DateTimeTransformer,
  },
  Threshold: {
    startDate: DateTimeTransformer,
  },
  Query: {
    lastViewedSystemAlarmsDate: DateTimeTransformer,
  },
}

export default createTransformerLink(transformers)
